"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DETECTION_ID_ONLY_REGEX = exports.DETECTION_INCLUDE_ONLY_REGEX = exports.DETECTION_CATCH_ALL_WITH_EXCLUSION_REGEX = exports.DETECTION_CATCH_ALL = exports.CATCH_ALL_REGEX = void 0;
/*! Copyright (c) 2019, XAPPmedia */
exports.CATCH_ALL_REGEX = /^.*$/;
exports.DETECTION_CATCH_ALL = /^\^?\.\*\$?$/;
exports.DETECTION_CATCH_ALL_WITH_EXCLUSION_REGEX = /^\^?\(\?\!\(((?:\^?[\w\d]*\$?\|?)*)\)\)\.\*\$?$/;
exports.DETECTION_INCLUDE_ONLY_REGEX = /^((?:[\^?[\w\d]*\$?\|?)*)$/;
exports.DETECTION_ID_ONLY_REGEX = /^[\w\d]*$/;
//# sourceMappingURL=Constants.js.map